import { tt } from '@agos/shared'
import { cn } from '@agos/ui'

import { LINE_NOTE_MAX, lineNoteOf } from './line-note'

/**
 * One basket line's note for the kitchen - `FRONTEND.md` §9.690, owner #3 (O55).
 *
 * **Labelled *Poznámka k položke*, never *Poznámka*.** That is the order note's label (`CartNotes`),
 * and a second control answering to it would make every spec that finds the order note by its label
 * find two. The placeholder says who reads it, because that is what decides what to write.
 *
 * **An input, not a textarea**: one line is what a kitchen card can show under an item, and the
 * server's 200 characters are a phrase rather than a paragraph. `maxLength` stops at the server's
 * limit, so its refusal is never met from this screen.
 *
 * A line that cannot be edited here - an earlier round nobody unlocked - shows its note as text, and
 * shows nothing when it has none.
 */
export function LineNoteField({
  note,
  onChange,
  readOnly = false,
  className,
}: {
  note: string | undefined
  onChange?: (note: string) => void
  readOnly?: boolean
  className?: string
}) {
  if (readOnly || onChange === undefined) {
    const shown = lineNoteOf({ note })
    if (shown === undefined) return null
    return (
      <p
        data-line-note
        className={cn('text-[11px] italic text-amber-600 dark:text-amber-400', className)}
      >
        {shown}
      </p>
    )
  }
  return (
    <input
      type="text"
      value={note ?? ''}
      maxLength={LINE_NOTE_MAX}
      onChange={(event) => onChange(event.target.value)}
      placeholder={tt('Poznámka pre kuchyňu')}
      aria-label={tt('Poznámka k položke')}
      data-line-note-input
      className={cn(
        'w-full px-2 py-1 rounded-lg bg-background border border-dashed border-border text-[11px] italic outline-none placeholder:not-italic focus:border-solid focus:ring-2 focus:ring-primary/20',
        lineNoteOf({ note }) !== undefined && 'border-amber-500/50 text-amber-700 dark:text-amber-300',
        className,
      )}
    />
  )
}
